import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import { Link } from 'react-router-dom';

type PreviewProps = {
  facility: Partial<Facility>;
  inline?: boolean;
};

const Preview: React.FC<PreviewProps> = (props) =>
  <span>
    <Link to={`/facilities/view/${props.facility.id}`}>{props.facility.name}</Link>
    {!props.inline ? <br /> : ' '}
    <small><em>{props.facility.city}, {props.facility.state}</em></small>
  </span>

export default Preview;
